// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"150":"c3a60b2f","371":"871fe437","658":"b85e8afb","931":"ff28dca6","989":"69bc3f73"}[chunkId] + ".chunk.css";
};